import { render, staticRenderFns } from "./DevirYD.vue?vue&type=template&id=80cec10e&"
import script from "./DevirYD.vue?vue&type=script&lang=js&"
export * from "./DevirYD.vue?vue&type=script&lang=js&"
import style0 from "./DevirYD.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports